import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_placeholder');

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const PRICE_IDS = {
  pro_monthly: process.env.REACT_APP_STRIPE_PRO_MONTHLY || 'price_pro_monthly',
  pro_yearly: process.env.REACT_APP_STRIPE_PRO_YEARLY || 'price_pro_yearly',
  premium_monthly: process.env.REACT_APP_STRIPE_PREMIUM_MONTHLY || 'price_premium_monthly',
  premium_yearly: process.env.REACT_APP_STRIPE_PREMIUM_YEARLY || 'price_premium_yearly',
};

function getAuthToken() {
  return localStorage.getItem('access_token') || '';
}

export async function redirectToCheckout(priceId) {
  const token = getAuthToken();

  if (!token) {
    window.location.href = '/signup';
    return { success: false, error: 'not_authenticated' };
  }

  try {
    const response = await fetch(`${API_URL}/api/billing/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ price_id: priceId }),
    });

    if (response.status === 401 || response.status === 403) {
      window.location.href = '/login';
      return { success: false, error: 'not_authenticated' };
    }

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      return { success: false, error: err.detail || 'checkout_failed' };
    }

    const data = await response.json();
    if (data.url) {
      window.location.href = data.url;
      return { success: true };
    }
    return { success: false, error: 'no_url' };
  } catch (error) {
    console.error('Checkout error:', error.message);
    return { success: false, error: 'network' };
  }
}

export async function redirectToPortal() {
  try {
    const response = await fetch(`${API_URL}/api/billing/create-portal-session`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`,
      },
    });

    if (!response.ok) throw new Error('Failed to create portal session');

    const { url } = await response.json();
    window.location.href = url;
  } catch (error) {
    console.error('Portal error:', error.message);
  }
}

export async function getBillingStatus() {
  const response = await fetch(`${API_URL}/api/billing/status`, {
    headers: { 'Authorization': `Bearer ${getAuthToken()}` },
  });
  if (!response.ok) throw new Error('Failed to get billing status');
  return response.json();
}

export async function getPaymentHistory() {
  const response = await fetch(`${API_URL}/api/billing/payments`, {
    headers: { 'Authorization': `Bearer ${getAuthToken()}` },
  });
  if (!response.ok) throw new Error('Failed to get payment history');
  return response.json();
}

export default stripePromise;
